import { TableBaseCols } from '@ge/feat-reporting/components/widgets/table-widget/table-base-cols';

// All available columns and groups for completed work
export const ExceptionDamagesColumns = {
  GROUP_SELECTED: TableBaseCols.GROUP_SELECTED,
  SELECTED: TableBaseCols.SELECTED,

  //GROUP_ASSET_DETAILS: 'Asset Details',
  GROUP_COLUMNS: 'Columns',
  SITE: 'Site',
  ASSET: 'Asset',
  MODEL: 'Model',
  COMPONENT: 'Component',
  LOCATION: 'Location',
  DAMAGE: 'Damage',
  PART: 'Part',
  CATEGORY: 'Category',
  MANUFACTURER: 'Manufacturer',
  RUL_START_DATE: 'IndicationDate',
  P90: 'p90',
};

// Completed work table configuration
export const exceptionDamagesColumnsDefs = {
  [ExceptionDamagesColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'external_damages.columns.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [ExceptionDamagesColumns.SITE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.site',
            a11yDefault: 'Site',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.ASSET]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.asset_name',
            a11yDefault: 'Asset',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.MODEL]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.model',
            a11yDefault: 'Model',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.COMPONENT]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.component',
            a11yDefault: 'Component',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.LOCATION]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.location',
            a11yDefault: 'Location',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.DAMAGE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.damage',
            a11yDefault: 'Damage',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.PART]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.part',
            a11yDefault: 'Part',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.CATEGORY]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.category',
            a11yDefault: 'Category',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.MANUFACTURER]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.manufacturer',
            a11yDefault: 'Manufacturer',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.RUL_START_DATE]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.rul_start_date',
            a11yDefault: 'RUL Start Date',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ExceptionDamagesColumns.P90]: {
        labels: [
          {
            a11yKey: 'external_damages.columns.p90',
            a11yDefault: 'P90',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const exceptionDamagesColumnsDefaultCols = [
  {
    id: ExceptionDamagesColumns.GROUP_COLUMNS,
    ignoreTemplateConfig: true,
    cols: [
      {
        id: ExceptionDamagesColumns.SITE,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.ASSET,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.MODEL,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.COMPONENT,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.LOCATION,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.DAMAGE,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.PART,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.CATEGORY,
        visible: true,
      },
      {
        id: ExceptionDamagesColumns.MANUFACTURER,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ExceptionDamagesColumns.RUL_START_DATE,
        visible: false,
        ignoreTemplateConfig: true,
      },
      {
        id: ExceptionDamagesColumns.P90,
        visible: false,
        ignoreTemplateConfig: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
